import { useState } from "react";
import Navbar from "./Components/Navbar";
import SearchBar from "./Components/SearchBar";
import WeatherDetails from "./Components/WeatherDetails";


function App() {

  const [showWeatherDetails, setShowWeatherDetails]= useState(false);
  const [searchCityData, setSearchCityData]= useState(null);

  return (
    <div className="content" >
      <Navbar/>
      <SearchBar setShowWeatherDetails= {setShowWeatherDetails} setSearchCityData={setSearchCityData}/>
      {
        showWeatherDetails && <WeatherDetails searchCityData= {searchCityData}/>
      }
    </div>

  );
}

export default App;
